import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { fetchTemplates, AddTemplate } from "../services/templateService";
import "./TemplateManager.css";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import editicon from "../../images/edit-icon.svg";
import eyeimg from "../../images/eye.svg";
import Loader from "../../utils/Loader";

const TemplateManager = () => {
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    recipientType: "",
    subject: "",
    body: "",
    templateId: null,
  });
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [showEditModel, setShowEditModel] = useState(false);
  const [showVoewModel, setShowViewModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleClose = () => {
    setShowEditModel(false);
    setShowViewModel(false);
  };

  const [searchText, setSearchText] = useState("");

  // Fetch templates on component mount
  useEffect(() => {
    fetchTemplatesList();
  }, [limit, page]);

  // Fetch templates from API
  const fetchTemplatesList = async (searchText, sortby) => {
    setLoading(true);
    try {
      const response = await fetchTemplates({
        page: page + 1,
        limit,
        searchKey: searchText || "",
        sortBy: sortby || "",
      });
   
      setTotalPages(response?.data?.totalPages || 0);
      setTotalItems(response?.data?.totalItems || 0);
      if (Array.isArray(response.data.items)) {
        setTemplates(response.data.items);
      } else {
        console.error("Invalid data format");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error("Error fetching templates", error);
    }
  };

  // Handle input changes for text fields
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const stripHtmlTags = (html) => {
    let doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  // Handle Quill editor changes
  const handleQuillChange = (value) => {
    if (formData.recipientType == "email") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        body: value || "",
      }));
    } else {
      const plainText = value;
      setFormData((prevFormData) => ({
        ...prevFormData,
        body: plainText || "",
      }));
    }
  };

  // Handle form submission for adding/updating templates
  const handleSubmit = async (e) => {
    e.preventDefault();
    handleClose();
    try {
      if (selectedTemplate) {
        await AddTemplate({ ...formData, templateId: selectedTemplate._id });
      } else {
        await AddTemplate(formData);
      }

      await fetchTemplatesList(); // Refresh template list
      resetForm();
    } catch (error) {
      handleClose();

      console.error("Error saving template", error);
    }
  };

  // Reset form fields
  const resetForm = () => {
    setFormData({ name: "", type: "", subject: "", body: "" });
    setSelectedTemplate(null);
  };

  // Handle edit button click - update form with selected template
  const handleEdit = (template) => {
   
    setSelectedTemplate(template);

    setFormData({
      name: template.name || "",
      type: template.type || "",
      subject: template.subject || "",
      body: template.body || "",
      recipientType: template.recipientType || "",
    });

    setShowEditModel(true);
  };

  const handleView = (template) => {
    setFormData({
      name: template.name || "",
      type: template.type || "",
      subject: template.subject || "",
      body: template.body || "",
      recipientType: template.recipientType || "",
    });

    setShowViewModel(true);
  };

  const handleSelect = (eventKey) => {
    setSelectedSortValue(eventKey); // Update the state with the selected value
    fetchTemplatesList(searchText, eventKey);
  };
  const handleSearchChange = async (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      await fetchTemplatesList(query, selectedSortValue);
    }
    // setLoading(false)
  };

  // pagination logic
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Header options
      ["bold", "italic", "underline", "strike"], // Basic text formatting
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ script: "sub" }, { script: "super" }], // Superscript & Subscript
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      [{ direction: "rtl" }], // Text direction

      [{ color: [] }, { background: [] }], // Text and background color
      [{ font: [] }], // Font selection
      [{ align: [] }], // Text alignment
      ["blockquote", "code-block"], // Enables Code Block (HTML/Code View)
      ["link", "image"], // 🔥 Insert Link & Image
      [
        { undo: "undo" }, // 🔄 Undo
        { redo: "redo" }, // 🔄 Redo
      ],
      ["clean"], // Remove formatting
    ],
  };

  return (
    <>
      {loading && <Loader />}
      <div className="Dashboard-wrapper mt-4">
        <div className="row">
          <div className="add-doctor">
            <Form>
              <Form.Group controlId="searchInput">
                <Form.Control
                  type="search"
                  aria-label="Search"
                  value={searchText}
                  onChange={handleSearchChange}
                  placeholder="Search templates by name..."
                />
              </Form.Group>
            </Form>

            {/* Button to trigger modal */}

            <Dropdown
              className="patient-info-dropdown "
              onSelect={handleSelect}
            >
              <Dropdown.Toggle className="db-dropdown h-100 ">
                {selectedSortValue === ""
                  ? "Sort By"
                  : selectedSortValue === "name-asc"
                  ? "Name A-Z"
                  : "Name Z-A"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="">Default</Dropdown.Item>
                <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
                <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
                {/* <Dropdown.Item eventKey="low-icbps">Low ICBPS</Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="table-responsive dashboard-table">
            <table className="patients-table">
              <thead>
                <tr className="t-row-block">
                  <th scope="col">Sr No</th>
                  <th scope="col">Template Name</th>
                  <th scope="col">Type</th>
                  <th scope="col">Recipient Type </th>

                  <th scope="col">Subject</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {templates.length > 0 ? (
                  templates.map((data, index) => (
                    <tr key={data.id || index}>
                      <td scope="row">{++index}</td>
                      <td>{data.name}</td>
                      {/* <td>{data.type}</td> */}
                      <td>
                        {data?.type
                          ?.split("_")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")}
                      </td>
                      <td>{data.recipientType == 'email' ? 'Email' : 'SMS'}</td>
                      <td>{data.subject}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <a
                            className="edit-del-icon eye-edit-del edit-img"
                            onClick={() => {
                              handleEdit(data);
                            }}
                          >
                            <img src={editicon} alt="edit" />
                          </a>

                          <a
                            className="edit-del-icon eye-edit-del eye-img"
                            onClick={() => {
                              handleView(data);
                            }}
                          >
                            <img src={eyeimg} alt="view" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No template Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ************************************** Modal ********************************************************** */}

          {/* edit update the template */}
          <Modal
            show={showEditModel}
            onHide={handleClose}
            centered
            className="report-modal report-popup-modal templateModel"
          >
            <Modal.Header closeButton className="header text-white m-0">
              <Modal.Title>Template</Modal.Title>
            </Modal.Header>
            <Modal.Body
              className="templateModel p-4"
              style={{ maxHeight: "500px", overflowY: "auto" }}
            >
              {error && <Alert variant="danger">{error}</Alert>}
              <Form className="text-start" onSubmit={handleSubmit}>
                {/* Template Name */}
                <Form.Group controlId="templateName" className="mb-3">
                  <Form.Label>Template Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter Template Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </Form.Group>

                {/* Template Type */}
                {/* <Form.Group controlId="templateType" className="mb-3">
                  <Form.Label>Template Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="type"
                    placeholder="e.g., register, login"
                    value={formData.type}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </Form.Group> */}

                {/* Recipient Type */}
                <Form.Group controlId="recipientType" className="mb-3">
                  <Form.Label>Recipient Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="recipientType"
                    placeholder="e.g., mobile, email"
                    value={formData.recipientType}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </Form.Group>

                {/* Email Subject */}
                <Form.Group controlId="emailSubject" className="mb-3">
                  <Form.Label>Email Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    placeholder="Enter Email Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                {/* Email Body */}
                <Form.Group controlId="emailBody" className="mb-3">
                  <Form.Label>Email Body</Form.Label>
                  <ReactQuill
                    value={formData.body || ""}
                    onChange={handleQuillChange}
                    className="mb-2"
                    modules={modules}
                  />
                </Form.Group>

                {/* Action Buttons */}
                <div className="d-flex gap-3 justify-content-end mt-4">
                  <Button
                    variant=""
                    onClick={handleClose}
                    // className="px-4 btn border-btn outlined-btn btn-no"
                    className="btn btn-primary outlined-btn"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    // className="px-4 btn dark-btn"
                    className="btn btn-primary filled-btn"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* view the template */}

          <Modal
            show={showVoewModel}
            onHide={handleClose}
            centered
            className="report-modal templateModel  report-popup-modal"
          >
            <Modal.Header
              closeButton
              className="header text-white white-close-btn"
            >
              <Modal.Title>Template </Modal.Title>
            </Modal.Header>
            <Modal.Body
              className="templateModel p-4"
              style={{ maxHeight: "500px", overflowY: "auto" }}
            >
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit} className="">
                {/* Subject Section */}
                <div className="mb-3 text-start">
                  <label className="form-label"> Subject </label>
                  <p className="border p-2 rounded bg-light">
                    {formData.subject || "N/A"}
                  </p>
                </div>

                {/* Body Section */}
                <div className="mb-3 text-start">
                  <label className="form-label">Content</label>
                  <div
                    className="border p-3 rounded bg-light"
                    dangerouslySetInnerHTML={{ __html: formData.body || "" }} // Rendering HTML directly
                  ></div>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
        <div className="pagination-blk">
          <CustomPagination
            totalItems={totalItems}
            page={page}
            onPageChange={handleChangePage}
            limit={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default TemplateManager;
